import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FillDraftOfferService {
    private info: Subject<any> = new BehaviorSubject<any>(false);

    get info$() {
        return this.info.asObservable();
    }

    sendDraft(draft: any) {
        this.info.next(draft);
    }

}